import React, { useState } from "react";
import { NavLink } from "react-router-dom";

const links = [
  { label: "CONÓZCANOS", to: "/conozcanos" },
  { label: "SERVICIO", to: "/servicio" },
  { label: "NOM-035", to: "/nom35" },
  { label: "CONEXIÓN SIETE", to: "/conexion-siete" },
  { label: "CONTACTO", to: "/contacto" },
];

export default function AppNavbar() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => setIsMenuOpen((v) => !v);
  const closeMenu = () => setIsMenuOpen(false);

  const navClass = ({ isActive }) =>
    [
      "pb-1 uppercase transition-colors",
      "hover:text-brand-lavender",
      isActive
        ? "border-b-2 border-brand-lavender font-semibold text-brand-navy"
        : "border-b-2 border-transparent text-brand-navy",
    ].join(" ");

  const mobileClass = ({ isActive }) =>
    [
      "block px-4 py-3 text-sm uppercase tracking-[0.16em] rounded-md transition-colors",
      "hover:bg-brand-beige hover:text-brand-navy",
      isActive
        ? "bg-brand-beige text-brand-navy font-semibold border-l-4 border-brand-lavender"
        : "text-brand-navy",
    ].join(" ");

  return (
    <header className="bg-white border-b border-brand-lilac/60 relative z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-4 flex items-center justify-between">
        <div className="flex items-center">
          <NavLink to="/" onClick={closeMenu}>
            <img
              src="/images/Logo-v2.svg"
              alt="EAP Consulting"
              className="h-10 sm:h-12 w-auto cursor-pointer"
            />
          </NavLink>
        </div>

        <nav className="hidden md:flex items-center gap-6 lg:gap-10 text-sm tracking-[0.12em] lg:tracking-[0.16em]">
          {links.map((link) => (
            <NavLink key={link.to} to={link.to} className={navClass}>
              {link.label}
            </NavLink>
          ))}
        </nav>

        <button
          onClick={toggleMenu}
          className="md:hidden p-2 text-brand-navy hover:text-brand-lavender transition-colors"
          aria-label="Toggle menu"
          aria-expanded={isMenuOpen}
        >
          {isMenuOpen ? (
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          ) : (
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
            </svg>
          )}
        </button>
      </div>

      {isMenuOpen && (
        <>
          <div
            className="fixed inset-0 bg-black/40 z-40 md:hidden"
            onClick={closeMenu}
          />
          <nav className="absolute top-full left-0 right-0 bg-white border-b border-brand-lilac/60 shadow-lg z-50 md:hidden">
            <div className="px-4 py-4 space-y-2">
              {links.map((link) => (
                <NavLink key={link.to} to={link.to} onClick={closeMenu} className={mobileClass}>
                  {link.label}
                </NavLink>
              ))}
            </div>
          </nav>
        </>
      )}
    </header>
  );
}
